import { render, staticRenderFns } from "./VaimoPhoneInput.vue?vue&type=template&id=01127020&"
import script from "./VaimoPhoneInput.vue?vue&type=script&lang=ts&"
export * from "./VaimoPhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoPhoneInput.vue?vue&type=style&index=0&id=01127020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports